<template>
  <header ref="header" class="header">
    <div class="header__top">
      <div class="wrapper">
        <div class="header__button header__button-burger">
          <UIButton variant="secondary" @click="onOpenBurger">
            <NuxtIcon name="IconMenu" />
          </UIButton>
        </div>
        <NuxtLink class="header__logo" :to="{ name: 'home', params: { chapters: 'index' } }">
          <NuxtIcon name="IconHeaderLogo" filled />
        </NuxtLink>
        <div class="header__addresses desktop-only">
          <div v-for="affiliate in affiliates" :key="affiliate.id" class="header-address">
            <div v-if="affiliate.working_time" class="header-address__row">
              <NuxtIcon name="IconClock" filled />
              {{ affiliate.working_time }}
            </div>
            <div v-if="affiliate.address" class="header-address__row">
              <NuxtIcon name="IconMapPin" filled />
              {{ affiliate.address }}
              <span v-if="affiliate.title" class="text-color"
                ><b>{{ affiliate.title }}</b></span
              >
            </div>
          </div>
        </div>
        <div class="header__buttons">
          <div class="header__button header__button-phone desktop-only">
            <UIButton
              v-if="affiliates[1].phone"
              button-variant="primary"
              type="link"
              :link="`tel:${affiliates[1].phone}`"
              @click="goalsClickHeaderPhone"
            >
              <NuxtIcon name="IconPhone" filled />
              <span class="btn__text">{{ affiliates[1].phone }}</span>
            </UIButton>
          </div>
          <div class="header__button header__button-mail-pc desktop-only">
            <UIButton variant="primary" size="xl" @click="openFeedback">
              Записаться
            </UIButton>
          </div>
          <div class="header__button header__button-search-pc">
            <UIButton variant="primary" size="xl" @click="isOpenSearchModal = true">
              <NuxtIcon name="IconSearch" filled />
            </UIButton>
          </div>
          <div class="header__button desktop-only">
            <UIButton class="header__button header__buttons-glasses bvi-open">
              <NuxtIcon name="IconGlasses" />
            </UIButton>
          </div>
        </div>
      </div>
    </div>

    <div class="header__bottom" @mouseleave="closeWindows">
      <div class="wrapper">
        <div class="header__middle" :class="{ 'header__middle-open': isOpenBurger }">
          <div v-if="isOpenBurger" class="header__middle-mobile">
            <NuxtIcon name="IconCancel" @click="onCloseBurger" />
          </div>
          <div class="header__nav">
            <nav class="header__menu">
              <ul class="header__menu-list">
                <li class="header__menu-item">
                  <NuxtLink
                    class="header__menu-link header__nav-services-pc"
                    to="/services"
                    @mouseenter="openServicesMenu"
                  >
                    Услуги
                  </NuxtLink>
                  <div
                    class="header__nav-services-mob header__menu-link"
                    :class="{ 'is-open': showServices }"
                    @click="toggleServices"
                  >
                    Услуги
                    <span class="header__menu-chevron" :class="{ 'is-open': showServices }">
                      <NuxtIcon name="IconChevronVerticalSmall" />
                    </span>
                  </div>
                  <CHeaderServices
                    v-if="isServicesOpen"
                    ref="servicesList"
                    @on-close="isServicesOpen = !isServicesOpen"
                  />
                  <Transition name="header-mobile-submenu">
                    <div v-if="width <= 768 && showServices" class="header-mobile-submenu">
                      <div class="header-mobile-submenu__inner">
                        <CHeaderServicesMobile />
                      </div>
                    </div>
                  </Transition>
                </li>
                <li
                  v-for="(item, index) in menuItems"
                  :key="`header_${index}_${item.slug}`"
                  class="header__menu-item"
                  :class="{'doctors-menu-item': isDoctorsMenuItem(item)}"
                  @mouseenter="openSubMenu(index, item)"
                >
                  <template v-if="isDoctorsMenuItem(item)">
                    <NuxtLink
                      class="header__menu-link header__nav-doctors-pc"
                      to="/doctors"
                    >
                      {{ item.title }}
                      <NuxtIcon
                        v-if="item.children.length > 0"
                        name="IconChevronVerticalSmall"
                      />
                    </NuxtLink>
                    <div
                      class="header__nav-doctors-mob header__menu-link"
                      :class="{ 'is-open': showDoctors }"
                      @click="toggleDoctors"
                    >
                      {{ item.title }}
                      <span class="header__menu-chevron" :class="{ 'is-open': showDoctors }">
                        <NuxtIcon name="IconChevronVerticalSmall" />
                      </span>
                    </div>
                  </template>
                  <NuxtLink
                    v-else
                    class="header__menu-link"
                    :to="getLink(item)"
                    :target="item.target"
                  >
                    {{ item.title }}
                    <NuxtIcon
                      v-if="item.children.length > 0"
                      ref="target"
                      name="IconChevronVerticalSmall"
                    />
                  </NuxtLink>
                  <CHeaderDoctors
                    v-if="isDoctorsMenuItem(item) && width > 768 && isDoctorsOpen"
                  />
                  <Transition v-if="isDoctorsMenuItem(item) && width <= 768 && showDoctors" name="header-mobile-submenu">
                    <div
                      
                      class="header-mobile-submenu"
                    >
                      <div class="header-mobile-submenu__inner">
                        <CHeaderDoctorsMobile />
                      </div>
                    </div>
                  </Transition>
                  <ul
                    v-else-if="openSubMenuIndex === index && !isDoctorsMenuItem(item)"
                    class="header__sub-menu"
                  >
                    <li
                      v-for="(subItem, subIndex) in item.children"
                      :key="`header_${index}_${item.slug}_${subIndex}`"
                      class="header__sub-menu-item"
                    >
                      <NuxtLink
                        class="header__sub-menu-link"
                        :to="
                          subItem.type === 'direct_link'
                            ? subItem.url
                            : { name: 'home', params: { chapters: subItem.slug.split('/') } }
                        "
                        :target="subItem.target"
                      >
                        {{ subItem.title }}
                      </NuxtLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
            <div class="header__addresses mobile-only">
              <div v-for="affiliate in affiliates" :key="affiliate.id" class="header-address">
                <a
                  v-if="affiliate.phone"
                  :href="`tel:${affiliate.phone}`"
                  class="header-address__link"
                  >{{ affiliate.phone }}</a
                >
                <div v-if="affiliate.working_time" class="header-address__row">
                  <NuxtIcon name="IconClock" filled />
                  {{ affiliate.working_time }}
                </div>
                <div v-if="affiliate.address" class="header-address__row">
                  <NuxtIcon name="IconMapPin" filled />
                  {{ affiliate.address }}
                </div>
              </div>
            </div>
            <div v-if="config?.socials.length > 0" class="header__socials mobile-only">
              <template v-for="item in config.socials">
                <NuxtLink
                  v-if="item.link.length > 0"
                  :key="item.name"
                  :to="item.link"
                  target="_blank"
                >
                  <NuxtIcon v-if="item.name" :name="`IconSocial${item.name}`" filled />
                </NuxtLink>
              </template>
            </div>
            <!-- <a v-if="width < 1340" href="">Карта сайта</a> -->
          </div>
        </div>

        <div class="header__mob mobile-only">
          <template v-for="affiliate in affiliates" :key="affiliate.id">
            <div class="header-address">
              <span class="text-color">{{ affiliate.title }}</span>
            </div>
          </template>
          <span>{{ affiliates[1].working_time }}</span>
          <a @click="goalsClickHeaderPhone" class="header__link" :href="`tel:${affiliates[1].phone}`">{{ affiliates[1].phone }}</a>
        </div>
      </div>
    </div>
    
    <CHeaderSearch v-if="isOpenSearchModal" v-model="isOpenSearchModal" />
  </header>
</template>

<script setup lang="ts">
import type { MenuItem } from '@/types/menu';
import './styles.scss';
import { watch, onMounted, ref, useRouter, useState, nextTick, useRequestURL, navigateTo, useServicesIconName, useSlugTransform } from '#imports';
import { onClickOutside } from '@vueuse/core';
import UIButton from '@/components/UI/button/UIButton.vue';
import UIButtonRounded from '@/components/UI/buttonRounded/UIButtonRounded.vue';
import CHeaderServices from '~/components/headerServices/CHeaderServices.vue';
import CHeaderServicesMobile from '~/components/headerServices/CHeaderServicesMobile.vue';
import CHeaderDoctors from '~/components/header/CHeaderDoctors.vue';
import CHeaderDoctorsMobile from '~/components/header/CHeaderDoctorsMobile.vue';
import CHeaderSearch from '~/components/headerSearch/CHeaderSearch.vue';
import { useFeedbackWidget } from '~/composables/useFeedbackWidget';
import type { OfficeItem } from '~/types/pages';
import { yandexRichGoals } from '~/composables/yandexRichGoals';
import type { ClientConfigResponse } from '~/types/client/init';
import { useWindowSize } from '@vueuse/core';
import type { ServicesResults } from '~/types/pages';

const servicesCatalog = useState<ServicesResults[]>('servicesCatalog');

const { width } = useWindowSize();


interface Props {
  menuItems: MenuItem[];
  headerPhone?: string;
  headerEmail?: string;
}

defineProps<Props>();

const url = useRequestURL().origin;

const openSubMenuIndex = ref<number | null>(null);
const isDoctorsOpen = ref(false);
const headerAffiliates = ref();
const openSubMenu = (index: number, item: MenuItem) => {
  if (width.value <= 768) {
    return;
  }

  isServicesOpen.value = false;
  isDoctorsOpen.value = isDoctorsMenuItem(item);
  openSubMenuIndex.value =
    !isDoctorsOpen.value && item.children.length > 0 ? index : null;
};

const isDoctorsMenuItem = (item: MenuItem) => {
  const title = item.title.trim().toLocaleLowerCase('ru-RU');
  const slug = item.slug.toLocaleLowerCase('ru-RU');
  const link = item.url.toLocaleLowerCase('ru-RU');

  return title === 'врачи' || slug.includes('doctor') || link.includes('/doctors');
};

const target = ref(null);

const isOpenBurger = ref(false);
const isOpenAffiliates = ref(false);
const showServices = ref(false);
const showDoctors = ref(false);

const onCloseBurger = () => (isOpenBurger.value = false);
const onOpenBurger = () => (isOpenBurger.value = true);

function getLink(item: MenuItem) {
  const routeLink = {};
  if (item.type === 'direct_link') {
    return `${url}${item.url}`;
  } else {
    routeLink.name = 'home';
    routeLink.params = { chapters: item.slug.replace('index', '').split('/') };
    routeLink.hash = item.anchor;
  }
  return routeLink;
}

const isServicesOpen = ref(false);

const servicesList = ref(null);
function bindClickEvents(firstElementSelector: string, secondElementSelector: string) {
  const firstElement = document.querySelector(firstElementSelector);
  const secondElement = document.querySelector(secondElementSelector);

  if (!firstElement || !secondElement) {
    console.error('One or both elements not found');
    return;
  }

  firstElement.addEventListener('click', () => {
    secondElement.click();
  });
}

onMounted(() => {
  const firstElement = document.querySelector('.header__button-mail-pc .button');
  const secondElement = document.querySelector('.header__button-mail-mob .button-rounded');

  secondElement?.addEventListener('click', () => {
    firstElement?.click();
  });

  onClickOutside(target, () => {
    openSubMenuIndex.value = null;
  });

  onClickOutside(headerAffiliates, () => {
    isOpenAffiliates.value = false;
  });

  onClickOutside(servicesList, () => {
    isServicesOpen.value = false;
  });
});

const router = useRouter();
const route = router.currentRoute.value;

const { goalsClickHeaderPhone } = yandexRichGoals();

router.beforeEach(() => {
  isOpenBurger.value = false;
  isServicesOpen.value = false;
  showServices.value = false;
  showDoctors.value = false;
  openSubMenuIndex.value = null;
  isDoctorsOpen.value = false;
});

const isOpenSearchModal = ref(false);

const { open: openFeedback } = useFeedbackWidget();

const config = useState<ClientConfigResponse>('config');
const affiliates = useState<OfficeItem[]>('affiliates');

const closeWindows = () => {
  if (width.value > 768) {
    isServicesOpen.value = false;
    isDoctorsOpen.value = false;
    openSubMenuIndex.value = null;
  }
};

const openServicesMenu = () => {
  if (width.value <= 768) {
    return;
  }

  isServicesOpen.value = true;
  isDoctorsOpen.value = false;
  showDoctors.value = false;
  openSubMenuIndex.value = null;
};

const toggleServices = () => {
  showServices.value = !showServices.value;
  showDoctors.value = false;
};

const toggleDoctors = () => {
  showDoctors.value = !showDoctors.value;
  showServices.value = false;
};
</script>
